import axios from 'axios'

const rewardCampaignApiClient = axios.create({
  baseURL: window.app.rewardcampaign.typo3_base_url,
  headers: {
    'Content-Type': 'multipart/form-data',
  }
})

rewardCampaignApiClient.interceptors.request.use(config => {
  if (config.url === 'rewardcampaignapi/reward-campaign/') {
    config.url = `${config.baseURL}rewardcampaignapi/reward-campaign/`
  }
  return config
})

export default rewardCampaignApiClient

export const postRewardCampaignData = async (params, formData) => {
  try {
    const searchParams = new URLSearchParams(params).toString()
    const url = `rewardcampaignapi/reward-campaign/?${searchParams}`
    const response = await rewardCampaignApiClient.post(url, formData, {
      params: params
    })

    return response.data
  } catch (error) {
    console.log('Error:', error)
    return -1
  }
};
